import { useEffect, useState } from "react";
import Login from "./Login";
import Categories from "./Categories";
import Dishes from "./Dishes";
import OpeningHours from "./OpeningHours";
import MenuImages from "./MenuImages";
import Statistics from "./Statistics"; // ✅ NEW IMPORT

export default function Admin() {
  const [authed, setAuthed] = useState(false);
  const [tab, setTab] = useState("categories");

  useEffect(() => {
    const token = localStorage.getItem("token");
    setAuthed(!!token);
  }, []);

  const logout = () => {
    localStorage.removeItem("token");
    setAuthed(false);
    window.location.href = "/admin"; // Redirect back to login
  };

  // If not logged in → show login page
  if (!authed) {
    localStorage.removeItem("token");
    return <Login onSuccess={() => setAuthed(true)} />;
  }

  // Logged in → show dashboard
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #fffbe8 0%, #f8ecd2 100%)",
        color: "#222",
        padding: "1rem",
        fontFamily: "Inter, sans-serif",
      }}
    >
      {/* Header */}
      <header
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          gap: "0.75rem",
          marginBottom: "1.5rem",
        }}
      >
        <h1
          style={{
            fontSize: "clamp(20px, 2vw, 28px)",
            fontWeight: 800,
            margin: 0,
            color: "#b8860b",
          }}
        >
          Admin Panel
        </h1>

        <button
          onClick={logout}
          style={{
            padding: "8px 16px",
            borderRadius: 8,
            border: "none",
            background: "linear-gradient(90deg, #e0b144, #d4a017)",
            color: "#fff",
            fontSize: "14px",
            fontWeight: 600,
            cursor: "pointer",
            transition: "0.2s ease",
            boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
          }}
          onMouseEnter={(e) =>
            (e.target.style.background = "linear-gradient(90deg, #d4a017, #e0b144)")
          }
          onMouseLeave={(e) =>
            (e.target.style.background = "linear-gradient(90deg, #e0b144, #d4a017)")
          }
        >
          Logout
        </button>
      </header>

      {/* Tabs */}
      <nav
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "0.5rem",
          marginBottom: "1.25rem",
        }}
      >
        {[
          ["categories", "Categories"],
          ["dishes", "Dishes"],
          ["hours", "Opening Hours"],
          ["menuimages", "Midday Discount"],
          ["statistics", "Statistics"], // ✅ NEW TAB
        ].map(([key, label]) => (
          <button
            key={key}
            onClick={() => setTab(key)}
            style={{
              flex: "1 1 auto",
              minWidth: "140px",
              padding: "10px 16px",
              borderRadius: 8,
              border: tab === key ? "1px solid #d4a017" : "1px solid #ddd",
              background: tab === key ? "#d4a017" : "#fff",
              color: tab === key ? "#fff" : "#333",
              fontSize: "14px",
              fontWeight: 600,
              cursor: "pointer",
              boxShadow:
                tab === key
                  ? "0 2px 6px rgba(212,160,23,0.3)"
                  : "0 1px 3px rgba(0,0,0,0.05)",
              transition: "all 0.2s ease",
            }}
          >
            {label}
          </button>
        ))}
      </nav>

      {/* Main Content */}
      <main
        style={{
          background: "#fff",
          border: "1px solid #eee",
          borderRadius: 10,
          padding: "1.5rem",
          boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
          minHeight: "60vh",
          overflowX: "auto",
        }}
      >
        {tab === "categories" && <Categories />}
        {tab === "dishes" && <Dishes />}
        {tab === "hours" && <OpeningHours />}
        {tab === "menuimages" && <MenuImages />}
        {tab === "statistics" && <Statistics />} {/* ✅ NEW COMPONENT */}
      </main>

      {/* Footer */}
      <footer
        style={{
          textAlign: "center",
          fontSize: "13px",
          color: "#6b5b2b",
          marginTop: "1.5rem",
        }}
      >
        © {new Date().getFullYear()} Golden Arm Admin | All Rights Reserved
      </footer>
    </div>
  );
}
